import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './ShopSection.css';

const staticProducts = [
  { id: '1', name: 'Rice Sacks (20kg)', category: 'Groceries', image: 'https://www.healthysupplies.co.uk/pics/800x800/organic-white-basmati-rice-sussex-wholefoods-7RC06.webp?tsid=1679897020', price: 25, deal: 'Buy 5, Get 1 Free', bulkOptions: { '10kg': 15, '20kg': 25, '50kg': 55 } },
  { id: '2', name: 'Cola Cases (48-pack)', category: 'Beverages', image: 'https://m.media-amazon.com/images/I/61JlTYqyYyL._AC_UL480_FMwebp_QL65_.jpg', price: 18, deal: '20% Off Pallets', bulkOptions: { '24-pack': 10, '48-pack': 18, '96-pack': 34 } },
  { id: '3', name: 'Wipes Bulk (200-pack)', category: 'Household', image: 'https://m.media-amazon.com/images/I/61lBVjA7jrL._AC_UL480_FMwebp_QL65_.jpg', price: 15, deal: '30% Off 10+', bulkOptions: { '100-pack': 8, '200-pack': 15, '500-pack': 35 } },
  { id: '4', name: 'Crisps Crate (96-pack)', category: 'Snacks', image: 'https://m.media-amazon.com/images/I/815cdFlhZBL._AC_UL480_FMwebp_QL65_.jpg', price: 22, deal: '3-for-2', bulkOptions: { '48-pack': 12, '96-pack': 22, '192-pack': 40 } },
  { id: '5', name: 'Frozen Pizzas (20-pack)', category: 'Frozen', image: 'https://www.spar.co.uk/media/yryp2fvt/08abe9a4-102b-4bb1-8286-0f20f132ed89.jpg?anchor=center&mode=crop&heightratio=1&width=720&format=webp&quality=80&rnd=133051916644570000', price: 45, deal: '25% Off Bulk', bulkOptions: { '10-pack': 25, '20-pack': 45, '40-pack': 85 } },
  { id: '6', name: 'Shampoo Cases (24-pack)', category: 'Personal Care', image: 'https://m.media-amazon.com/images/I/61g4058UiJL._AC_SX679_PIbundle-24,TopRight,0,0_SH20_.jpg', price: 34, deal: '15% Off 5+', bulkOptions: { '12-pack': 18, '24-pack': 34, '48-pack': 65 } },
  { id: '7', name: 'Tea Bags (480-pack)', category: 'Beverages', image: 'https://m.media-amazon.com/images/I/717yNTlal6L._AC_UL480_FMwebp_QL65_.jpg', price: 16, deal: 'Buy 3, Save £5', bulkOptions: { '240-pack': 9, '480-pack': 16, '960-pack': 30 } },
  { id: '8', name: 'Toilet Rolls (72-pack)', category: 'Household', image: 'https://m.media-amazon.com/images/I/61SnIkJm7kL._AC_UL480_FMwebp_QL65_.jpg', price: 26, deal: '20% Off 10+', bulkOptions: { '36-pack': 14, '72-pack': 26, '144-pack': 50 } },
  { id: '9', name: 'Pasta Boxes (10kg)', category: 'Groceries', image: 'https://m.media-amazon.com/images/I/81GKjXfDsXL._AC_UL480_FMwebp_QL65_.jpg', price: 20, deal: '2-for-£35', bulkOptions: { '5kg': 12, '10kg': 20, '20kg': 38 } },
  { id: '10', name: 'Energy Drinks (24-pack)', category: 'Beverages', image: 'https://m.media-amazon.com/images/I/61SnIkJm7kL._AC_UL480_FMwebp_QL65_.jpg', price: 22, deal: '25% Off Cases', bulkOptions: { '12-pack': 12, '24-pack': 22, '48-pack': 40 } },
  { id: '11', name: 'Bleach Bottles (12-pack)', category: 'Household', image: 'https://m.media-amazon.com/images/I/71uad6OhVgL._AC_UL480_FMwebp_QL65_.jpg', price: 18, deal: 'Buy 5, Get 1 Free', bulkOptions: { '6-pack': 10, '12-pack': 18, '24-pack': 34 } },
  { id: '12', name: 'Chocolate Bars (48-pack)', category: 'Snacks', image: 'https://m.media-amazon.com/images/I/71MlQ4CXXrL._AC_UL480_FMwebp_QL65_.jpg', price: 24, deal: '30% Off Bulk', bulkOptions: { '24-pack': 14, '48-pack': 24, '96-pack': 45 } },
  { id: '13', name: 'Frozen Chips (10kg)', category: 'Frozen', image: 'https://m.media-amazon.com/images/I/71MlQ4CXXrL._AC_UL480_FMwebp_QL65_.jpg', price: 30, deal: '20% Off 5+', bulkOptions: { '5kg': 16, '10kg': 30, '20kg': 55 } },
  { id: '14', name: 'Soap Bars (20-pack)', category: 'Personal Care', image: 'https://m.media-amazon.com/images/I/51Ku4FMdpdL._AC_UL480_FMwebp_QL65_.jpg', price: 15, deal: '3-for-£40', bulkOptions: { '10-pack': 8, '20-pack': 15, '40-pack': 28 } },
  { id: '15', name: 'Coffee Jars (6-pack)', category: 'Beverages', image: 'https://images.unsplash.com/photo-1509042239860-f550ce710b93?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80', price: 28, deal: '15% Off Bulk', bulkOptions: { '3-pack': 15, '6-pack': 28, '12-pack': 50 } },
  { id: '16', name: 'Bin Bags (100-pack)', category: 'Household', image: 'https://m.media-amazon.com/images/I/71V4WbI05PL._AC_UL480_FMwebp_QL65_.jpg', price: 12, deal: 'Buy 10, Save £10', bulkOptions: { '50-pack': 7, '100-pack': 12, '200-pack': 22 } },
];

const ShopSection = ({ addToCart }) => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [filter, setFilter] = useState('All');
  const categories = ['All', 'Groceries', 'Beverages', 'Household', 'Snacks', 'Frozen', 'Personal Care'];

  const filteredProducts = filter === 'All' ? staticProducts : staticProducts.filter(p => p.category === filter);

  return (
    <section className="shop-section" id="shop">
      <motion.h2
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        Bulk Blitz Shop
      </motion.h2>
      <div className="shop-filters">
        {categories.map(cat => (
          <button
            key={cat}
            className={`filter-btn ${filter === cat ? 'active' : ''}`}
            onClick={() => setFilter(cat)}
          >
            {cat}
          </button>
        ))}
      </div>
      <div className="shop-grid">
        {filteredProducts.map((product) => (
          <motion.div
            key={product.id}
            className="shop-tile"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            whileHover={{ scale: 1.05 }}
            viewport={{ once: true }}
            onClick={() => setSelectedProduct(product)}
          >
            <img src={product.image} alt={product.name} className="tile-image" />
            <div className="deal-badge">{product.deal}</div>
            <div className="tile-content">
              <h3>{product.name}</h3>
              <p>{product.category}</p>
              <div className="bulk-options">
                {Object.entries(product.bulkOptions).map(([qty, price]) => (
                  <div key={qty} className="bulk-item">
                    <span>{qty}: £{price}</span>
                    <button onClick={(e) => { e.stopPropagation(); addToCart(product, qty, price); }}>Add</button>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        ))}
      </div>
      <AnimatePresence>
        {selectedProduct && (
          <ProductModal product={selectedProduct} onClose={() => setSelectedProduct(null)} addToCart={addToCart} />
        )}
      </AnimatePresence>
    </section>
  );
};

const ProductModal = ({ product, onClose, addToCart }) => {
  return (
    <motion.div
      className="shop-modal-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      onClick={onClose}
    >
      <motion.div
        className="shop-modal"
        initial={{ y: '-100vh' }}
        animate={{ y: 0 }}
        exit={{ y: '-100vh' }}
        transition={{ type: 'spring', stiffness: 200, damping: 20 }}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="modal-close" onClick={onClose}>×</button>
        <img src={product.image} alt={product.name} className="modal-image" />
        <div className="modal-content">
          <h3>{product.name}</h3>
          <p>{product.category} | Deal: {product.deal}</p>
          <div className="bulk-options">
            {Object.entries(product.bulkOptions).map(([qty, price]) => (
              <div key={qty} className="bulk-item">
                <span>{qty}: £{price}</span>
                <button onClick={() => addToCart(product, qty, price)}>Add to Cart</button>
              </div>
            ))}
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default ShopSection;